/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebsiteStatisticRequest
 */
export interface WebsiteStatisticRequest {
    /**
     * 
     * @type {Date}
     * @memberof WebsiteStatisticRequest
     */
    fromDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof WebsiteStatisticRequest
     */
    toDate?: Date;
}

/**
 * Check if a given object implements the WebsiteStatisticRequest interface.
 */
export function instanceOfWebsiteStatisticRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebsiteStatisticRequestFromJSON(json: any): WebsiteStatisticRequest {
    return WebsiteStatisticRequestFromJSONTyped(json, false);
}

export function WebsiteStatisticRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebsiteStatisticRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fromDate': !exists(json, 'fromDate') ? undefined : (new Date(json['fromDate'])),
        'toDate': !exists(json, 'toDate') ? undefined : (new Date(json['toDate'])),
    };
}

export function WebsiteStatisticRequestToJSON(value?: WebsiteStatisticRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fromDate': value.fromDate === undefined ? undefined : (value.fromDate.toISOString().substr(0,10)),
        'toDate': value.toDate === undefined ? undefined : (value.toDate.toISOString().substr(0,10)),
    };
}

